import React from "react";
import { useField, useFormikContext } from "formik";
import { Input, InputProps } from "reactstrap";
import { FormFieldRow } from "../misc/formFieldRow";

interface FormTextRowProps extends Omit<InputProps, "name" | "type"> {
    name: string;
    label: string;
    rows?: number;
    hidden?: boolean;
    required?: boolean;
}

export const FormTextRow = (props: FormTextRowProps) => {
    const [field, meta] = useField<string | undefined>(props.name);
    const { submitCount } = useFormikContext();
    const showError = meta.touched || submitCount > 0;
    const error =
        showError && typeof meta.error === "string" ? meta.error : undefined;
    const { label, hidden, rows, required, ...inputProps } = props;

    return (
        <FormFieldRow label={label} error={error} hidden={hidden} required={required}>
            <Input
                {...inputProps}
                id={props.name}
                name={props.name}
                type={props.rows ? "textarea" : "text"}
                rows={rows}
                required={required}
                value={field.value ?? ""}
                onChange={field.onChange}
                onBlur={field.onBlur}
                invalid={!!error}
            />
        </FormFieldRow>
    );
};